import React from 'react'

import './loading.css'

export default function Loading({show, small, mini}) {

    return show ? <div className={`loading ${small ? 'small' : ''} ${mini ? 'mini' : ''}`}></div> : null
}